import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { AppDispatch } from 'store'
import { getDeptOpsProfiles } from 'features/operations/deptOpsProfilesSlice'
import { getOpsRequests } from 'features/operations/opsRequestsSlice'
import { getLiveTasks } from 'features/operations/opsLiveTasksSlice'
import { getOpsEnviron } from 'features/operations/opsEnvironSlice'
import { getNeedsYouNotifications } from 'features/operations/opsNotificationsSlice'

export const useOpsBootstrap = () => {
  const dispatch = useDispatch<AppDispatch>()

  useEffect(() => {
    dispatch(getDeptOpsProfiles())
    dispatch(getOpsRequests({}))
    dispatch(getLiveTasks({}))
    dispatch(getOpsEnviron())
    dispatch(getNeedsYouNotifications())
  }, [dispatch])
}
